var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Troubleshooting } from '@/components/troubleshooting.component';
import { useStyledModal } from '@/hooks/use-styled-modal.hook';
import { ButtonBase, CircularProgress, styled, Typography, useMediaQuery, useTheme, } from '@mui/material';
import { useAnalytics } from 'hx-analytics';
import { useAudioPlayerContext } from 'hx-audio-player';
import { usePreviewLoop } from 'hx-din-test-2';
import { Slider } from 'hx-ui';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { BsVolumeOff, BsVolumeUp } from 'react-icons/bs';
import { palette } from '@/theme/palette';
export function VolumeSelect() {
    var theme = useTheme();
    var state = usePreviewLoop().dinPlayer.state;
    var _a = useFormContext(), getValues = _a.getValues, setValue = _a.setValue;
    var selectedVolume = getValues('volume');
    var setVolume = useAudioPlayerContext().setVolume;
    var sendButtonClick = useAnalytics().sendButtonClick;
    useEffect(function () {
        if (!selectedVolume) {
            setVolume(0.1);
            return;
        }
        setVolume(selectedVolume / 100);
    }, [selectedVolume]);
    var incrementVolume = function () { return setValue('volume', +selectedVolume + 10); };
    var decrementVolume = function () { return setValue('volume', +selectedVolume - 10); };
    var _b = useStyledModal(_jsx(Troubleshooting, {})), modal = _b[0], toggleModal = _b[1];
    var isMobile = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
    function soundNotPlayingClicked() {
        toggleModal();
        sendButtonClick('sound_check_explainer');
    }
    function formatLabel(value) {
        return "".concat(value / 10);
    }
    if (state.status === 'initializing')
        return (_jsx("div", __assign({ className: "grid w-full h-full place-items-center" }, { children: _jsx(CircularProgress, {}) })));
    return (_jsxs("div", __assign({ className: "flex flex-col gap-y-6 justify-center md:w-full items-center md:px-16 px-6" }, { children: [_jsx(Typography, __assign({ variant: 'h2', className: 'mb-9' }, { children: "Adjust the volume to a comfortable listening level." })), _jsx(Slider, { orientation: 'horizontal', sx: {
                    border: 'none',
                    width: '100%',
                    height: '7px',
                    '& .MuiSlider-root': {
                        scale: 5,
                    },
                    '& .MuiSlider-track': {
                        border: 'none',
                        height: 7,
                    },
                    '& .MuiSlider-thumb': {
                        background: palette.secondary.main,
                    },
                    '& .MuiSlider-rail': {
                        background: palette.secondary.main,
                        height: '4px',
                    },
                    '& .MuiSlider-valueLabel': {
                        backgroundColor: 'transparent',
                        color: 'black',
                        fontWeight: 'bold',
                        top: '0px',
                        right: '-11px',
                    },
                }, step: 10, name: "volume", className: "flex flex-row gap-4 w-full lg:w-[882px]", valueLabelFormat: formatLabel, valueLabelDisplay: isMobile ? 'on' : 'off', BeforeIcon: _jsx(VolumeControl, __assign({ onClick: decrementVolume }, { children: _jsx(BsVolumeOff, { size: "2rem", color: theme.palette.secondary.main }) })), AfterIcon: _jsx(VolumeControl, __assign({ onClick: incrementVolume }, { children: _jsx(BsVolumeUp, { size: "2rem", color: theme.palette.secondary.main }) })) }), _jsx(ButtonBase, __assign({ className: "w-fit", onClick: soundNotPlayingClicked }, { children: _jsx(Typography, __assign({ className: "md:text-xl text-lg cursor-pointer text-eargo-night underline" }, { children: "Sound not playing?" })) })), modal] })));
}
var VolumeControl = styled('div')({
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
});
